import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Clock = ({ size, color = tailwindConfig.theme.colors.gray[600] }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.967 6.667c-18.4 0-33.3 14.933-33.3 33.333s14.9 33.333 33.3 33.333C58.4 73.333 73.334 58.4 73.334 40S58.4 6.667 39.967 6.667zm.033 60c-14.733 0-26.666-11.934-26.666-26.667 0-14.733 11.933-26.667 26.666-26.667 14.734 0 26.667 11.934 26.667 26.667 0 14.733-11.933 26.667-26.667 26.667z"
        fill="#555757"
      />
      <path d="M41.666 23.333h-5v20l17.5 10.5 2.5-4.1-15-8.9v-17.5z" fill={color} />
    </svg>
  );
};

export default Clock;
